export enum RenderingStatus {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  ENHANCEABLE = 'enhance'
}

export enum ProcessorFieldType {
  STRING = 'string',
  PDF = 'pdf'
}

export enum DataFieldType {
  TEXT = 'text',
  DATE = 'date',
  DATETIME = 'date_time',
  IMAGE = 'image',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
  NESTEDARRAY = 'nested_array'
}

export enum Filters {
  Incomplete,
  Enhanceable,
  AllFields
}

export enum Tabs {
  Rendered,
  DataEntry,
  Identity
}

export enum SAVING_STATUS {
  saving,
  saved,
  error
}

export enum DIRTY_STATUS {
  Dirty,
  Loading,
  UpToDate,
  Latest
}

export enum LOADING_STATUS {
  Loading,
  Loaded,
  Errored
}

export enum LEFT_SIDEBAR_TABS {
  General,
  Links
}
